import en from './en'
import zh from './zh'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const message = {
  en: { ...en, ...enLocale },
  zh: { ...zh, ...zhLocale }
}
export default message



// WEBPACK FOOTER //
// ./src/project/i18n/langs/index.js